// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Tg0vU","body":"styles_body__BBfNI","blueline":"styles_blueline__gVZ7c","noRecords":"styles_noRecords__M1G84"};